// extracted by mini-css-extract-plugin
export var addToCartButton = "_p2-b";
export var arrowButtonContainer = "_p2-9";
export var arrowButtonIcon = "_p2-a";
export var carouselArrowButton = "_p2-6";
export var carouselElementContainer = "_p2-1";
export var left = "_p2-7";
export var productDisplayCarouselContainer = "_p2-0";
export var productTileContainer = "_p2-2";
export var productTileImage = "_p2-4";
export var productTileImageContainer = "_p2-3";
export var productTileTitle = "_p2-5";
export var right = "_p2-8";
export var sliderOverflow = "_p2-c";